/**
 *
 *
 * @export
 * @param {*} response
 * @returns
 */
export function getSigninInfo(response) {
  return {
    type: "SIGNIN_RESPONSE_DATA",
    response
  };
}

/**
 *
 *
 * @export
 * @param {*} user
 * @param {*} password
 * @returns
 */
export function getUserAndPassword(password) {
  return {
    type: "SINGIN_GET_USER_PASSWORD",
    password
  };
}
